<template>
  <div class="product-page">
    <div class="main-container header-section">
      <div class="header-top">
        <h1 class="brand-title">PRODUCT CENTER</h1>
      </div>
      <div class="filter-bar">
        PERSONAL INFO
      </div>
    </div>
    <div class="main-container">
      <div style="width: 100%;max-width: 500px;">
        <el-form 
          ref="addressForm" 
          :model="form" 
          :rules="rules" 
          label-position="top" 
          class="custom-form"
          hide-required-asterisk
        >
          <el-form-item label="First Name" prop="firstName">
            <el-input v-model="form.firstName" placeholder="Enter your first name" clearable></el-input>
          </el-form-item>
          
          <el-form-item label="Last Name" prop="lastName">
            <el-input v-model="form.lastName" placeholder="Enter your last name" clearable></el-input>
          </el-form-item>

          <div class="form-footer">
            <el-button type="primary" class="save-btn" :loading="loading" @click="submitForm">
              UPDATE PERSONAL INFORMATION
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { updateInformation } from '@/api/member';
import Cookies from "js-cookie";
import { mapState } from "vuex";

export default {
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
      },
      rules: {
        firstName: [{ required: true, message: 'Please input your first name', trigger: 'blur' }],
        lastName: [{ required: true, message: 'Please input your last name', trigger: 'blur' }],
      },
      loading: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    }),
    userInfo() {
      if (!this.user) return {};
      try {
        return typeof this.user === 'string' ? JSON.parse(this.user) : this.user;
      } catch (e) {
        console.error('UserInfo parse error:', e);
        return {};
      }
    },
  },
  watch: {
    userInfo: {
      handler(val) {
        if (val && (val.firstName || val.lastName)) {
          this.initForm();
        }
      },
      immediate: true,
      deep: true
    }
  },
  activated() {
    this.initForm();
  },
  methods: {
    initForm() {
      // 封装初始化逻辑，避免代码重复
      this.form.firstName = this.userInfo.firstName || '';
      this.form.lastName = this.userInfo.lastName || '';
    },
    submitForm() {
      this.$refs.addressForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          
          updateInformation(this.form)
            .then(res => {
              if (res.code == 1) {
                this.$message({
                  message: 'Update successful',
                  type: 'success',
                });
                
                // 构造新的用户信息对象
                let updatedUser = {
                  ...this.userInfo,
                  firstName: this.form.firstName,
                  lastName: this.form.lastName,
                };
                const userStr = JSON.stringify(updatedUser);
                Cookies.set('user', userStr);
                this.$store.commit('setUser', userStr); 
              } else {
                this.$message({
                  message: res.message || 'Update failed',
                  type: 'error',
                });
              }
            })
            .catch(err => {
              console.error(err);
              this.$message.error('Network error, please try again later.');
            })
            .finally(() => {
              this.loading = false;
            });
        } 
      });
    }
  }
}
</script>

<style scoped lang="scss">
$serif-font: "NotoSerif", sans-serif;
// $sans-font: 'Helvetica Neue', Helvetica, Arial, sans-serif;
// 提取背景色变量，确保一致性
$bg-color: #FAF9F7; 
$primary-color: #2B231E;

.product-page {
  background-color: $bg-color;
  min-height: 100vh;
  padding: 0px 20px 40px;
  font-family: $serif-font;
  color: $primary-color;
}

.main-container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 20px;
}

.header-section {
  padding-top: 40px;
  margin-bottom: 40px;

  .header-top {
    margin-bottom: 20px;

    .brand-title {
      display: inline-block;
      font-family: $serif-font;
      font-size: 32px;
      font-weight: 900;
      text-transform: uppercase;
      letter-spacing: 1px;
      margin: 0;
      cursor: default;
    }
  }

  .filter-bar {
    font-family: $serif-font;
    display: flex;
    align-items: center;
    gap: 40px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
}

/* 表单样式定制 */
.custom-form {
  margin-top: 10px;

  ::v-deep .el-form-item {
    margin-bottom: 30px; 
    position: relative;
    
    /* 1. 定制 Label：浮动在边框上 */
    .el-form-item__label {
      position: absolute;
      top: 0;
      left: 12px;
      transform: translateY(-50%);
      background-color: $bg-color; 
      padding: 0 8px;
      z-index: 2;
      line-height: 1;
      font-size: 13px;
      color: #333;
      font-weight: bold;
      font-family: $serif-font;
      letter-spacing: 0.5px;
    }

    .el-input__inner {
      background-color: transparent; 
      border-radius: 2px; 
      border: 1px solid #DCDFE6;
      padding-left: 15px;
      font-family: $serif-font; 
      color: #333;
      transition: all 0.3s;
      &:focus { 
        border-color: $primary-color; 
      }
    }

    /* placeholder 字体样式 */
    input::placeholder {
      color: #C9CDD4;
      font-family: $serif-font;
      opacity: 0.6;
      font-weight: normal;
    }
    
    /* 去除 Input 聚焦时的默认阴影（可选） */
    .el-input.is-active .el-input__inner, 
    .el-input__inner:focus {
        border-color: $primary-color;
    }
  }

  .form-footer {
    text-align: left; /* 或者 center */
    margin-top: 40px;

    .save-btn {
      width: 100%;
      background-color: #5D4E46;
      border: 1px solid #5D4E46;
      border-radius: 2px;
      color: #fff;
      font-family: $serif-font;
      letter-spacing: 1px;
      padding: 15px 0;
      font-size: 14px;
      text-transform: uppercase;
      font-weight: bold;
      transition: all 0.3s;
      
      &:hover { 
        background-color: #4a3e38;
        border-color: #4a3e38;
        opacity: 0.9;
      }
      
      &:active {
        background-color: #3e322d;
      }
    }
  }
}
@media (max-width: 768px) {
    .filter-bar{
      font-size: 4rem !important;
    }
     ::v-deep .el-form-item__label, .save-btn{
      font-size: 4rem !important;
    }
    .save-btn{
      padding: 4rem 0 !important;
    }
}
</style>